// @flow
import React, { type Node } from 'react';
import { MdBook } from 'react-icons/md';
import HorizontalUserInfo from 'components/common/HorizontalUserInfo/HorizontalUserInfo';
import './SeriesTemplate.scss';

type Props = {
  user: {
    username: string,
    id: string,
    thumbnail: ?string,
    short_bio: ?string,
    display_name: ?string,
  },
  children: Node,
};

const SeriesTemplate = ({ user, children }: Props) => {
  return (
    <div className="SeriesTemplate">
      <HorizontalUserInfo user={user} />
      <div className="series-label">
        <MdBook />
        <span>시리즈</span>
      </div>
      {children}
    </div>
  );
};

export default SeriesTemplate;



// WEBPACK FOOTER //
// ./src/components/series/SeriesTemplate/SeriesTemplate.js